'use client';
import { Card as SharedCard } from '@launchstore/shared-puck';
import type { CardProps } from '@launchstore/shared-puck';
export const Card: any = SharedCard;
export type { CardProps };
export default Card;
